var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 511.999 511.999"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ff9811",
  d: "M.001 44.522H0v422.955h.001V256.001z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h511.999v341.325H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.337h511.999V153.6H0zm0 136.537h511.999v68.263H0zm0 136.525h511.999v68.263H0z",
  fill: "#0052b4"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M256.001 256.005l-256 170.663V85.332z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M83.478 211.479l11.05 34.01h35.763L101.36 266.51l11.049 34.011-28.931-21.02-28.931 21.02 11.051-34.011-28.931-21.021h35.761z"
})));

export default SvgCu;